import "./src/styles/global.css";

export const onPreRouteUpdate = ({ location, prevLocation }) => {
	if (typeof window === "undefined") return;
	// If navigating within the app (prevLocation exists) and destination is home, skip the index loader once
	if (prevLocation && location && location.pathname === "/") {
		window.__SKIP_INDEX_LOADER__ = true;
	}
};

// Send GA4 page_view on client-side route changes
export const onRouteUpdate = ({ location, prevLocation }) => {
	if (typeof window === "undefined") return;
	if (typeof window.gtag === "function") {
		// 初回ロード時（prevLocation なし）は SSR 側の gtag('config') が動くためスキップ
		if (!prevLocation) return;
		const path = location?.pathname + (location?.search || "");
		// GA4推奨: SPA遷移では config に page_path を渡してページビューを送信
		window.gtag("config", "G-MEHRJ4JXRF", {
			page_path: path,
		});
	}
};
